import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { queryClient } from "@/lib/queryClient";

export interface Grant {
  id: string;
  user_id: string;
  user_email: string | null;
  tier_id: string;
  source: string;
  granted_at: string;
  expires_at: string | null;
  used: boolean;
  granted_by: string | null;
  granted_by_email: string | null;
}

export function invalidateAdminGrants() {
  return queryClient.invalidateQueries({ queryKey: ["admin-grants"] });
}

export function useAdminGrants() {
  const query = useQuery({
    queryKey: ["admin-grants"],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("admin_list_grants");
      if (error) throw error;
      return (data as Grant[]) ?? [];
    },
    staleTime: 30_000,
  });

  return {
    data: query.data ?? [],
    grants: query.data ?? [],
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
